export const GLOBAL_SETTINGS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/global-settings", name: "Global Settings" },
];
